import { render, staticRenderFns } from "./ModuleSettings.vue?vue&type=template&id=56bb4f92&scoped=true&lang=pug&"
import script from "./ModuleSettings.vue?vue&type=script&lang=js&"
export * from "./ModuleSettings.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSettings.vue?vue&type=style&index=0&id=56bb4f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bb4f92",
  null
  
)

export default component.exports